// removed by extract-text-webpack-plugin
module.exports = {"home-banner-wrapper":"home-banner-wrapper","category-menu":"category-menu","wrap-list-category":"wrap-list-category","wrap-container-list-category":"wrap-container-list-category","view-more-category":"view-more-category","title-category":"title-category","category-menu-item":"category-menu-item","has-submenu":"has-submenu","item":"item","item-link":"item-link","category-sub-menu":"category-sub-menu","view-more-link":"view-more-link","home-banner":"home-banner","content-banner":"content-banner","fair-name":"fair-name","fair-time":"fair-time"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_HomeBanner.scss
// module id = ./components/home/sub-view/_HomeBanner.scss
// module chunks = 0